var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 2.53C17.7 2.82 19.9 5.2 19.9 8.08C19.9 10.96 17.7 13.35 14.88 13.63C16.72 12.46 17.96 10.42 17.96 8.08C17.96 5.74 16.74 3.7 14.9 2.53ZM18.03 14.96C20.56 16.41 22.27 19.13 22.27 22.25C22.27 22.62 22.16 22.95 21.99 23.25H23.21C23.76 23.25 24.21 22.8 24.21 22.25C24.21 18.59 21.53 15.54 18.02 14.96H18.03ZM21.27 22.25C21.27 18.17 17.95 14.86 13.88 14.86H8.89C4.81 14.86 1.5 18.18 1.5 22.25C1.5 22.8 1.95 23.25 2.5 23.25H20.27C20.82 23.25 21.27 22.8 21.27 22.25ZM8.89 16.86H13.88C16.51 16.86 18.71 18.76 19.18 21.25H3.59C4.06 18.75 6.26 16.86 8.89 16.86ZM16.96 8.08C16.96 5.01 14.46 2.5 11.38 2.5C8.3 2.5 5.8 5 5.8 8.08C5.8 11.16 8.3 13.66 11.38 13.66C14.46 13.66 16.96 11.16 16.96 8.08ZM14.96 8.08C14.96 10.05 13.36 11.66 11.38 11.66C9.4 11.66 7.8 10.06 7.8 8.08C7.8 6.1 9.4 4.5 11.38 4.5C13.36 4.5 14.96 6.1 14.96 8.08Z",
    fill: "#FF43AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersOn);
export default __webpack_public_path__ + "static/media/usersOn.846df91cc144dec11f7a5e3731065355.svg";
export { ForwardRef as ReactComponent };